// client/helper-methods.ts
import { Camera, CameraResultType } from "@capacitor/camera";
import { filter, fromEvent, switchMap, take, timer } from "rxjs";
import { dataURLtoFile } from "../db/files.js";
var download = (contents, name, contentType = "attachment/csv") => {
  const a = document.createElement("a");
  a.href = window.URL.createObjectURL(new Blob([contents], { type: contentType }));
  a.target = "_blank";
  a.download = name || "download.csv";
  document.body.appendChild(a);
  a.click();
  requestAnimationFrame(() => document.body.removeChild(a));
};
var downloadLink = async (href, name) => {
  const a = document.createElement("a");
  a.href = href;
  a.target = "_blank";
  a.download = name;
  document.body.appendChild(a);
  a.click();
  return new Promise(
    (resolve) => requestAnimationFrame(() => {
      document.body.removeChild(a);
      resolve();
    })
  );
};
var clickInputWithRejectHandler = (input) => new Promise((resolve, reject) => {
  let gotFiles = false;
  timer(1e3).pipe(
    switchMap(() => fromEvent(window, "mousemove")),
    filter(() => document.hasFocus()),
    take(1)
  ).subscribe(() => setTimeout(() => !gotFiles && reject(new Error("no files were selected")), 200));
  input.onchange = () => {
    gotFiles = !!input.files;
    resolve(input);
  };
  input.click();
});
async function askForTextFile(forcedEncodingOrOptions, options) {
  const forcedEncoding = typeof forcedEncodingOrOptions === "string" ? forcedEncodingOrOptions : forcedEncodingOrOptions?.forcedEncoding;
  options = typeof forcedEncodingOrOptions === "object" ? forcedEncodingOrOptions : options;
  const input = document.createElement("input");
  input.type = "file";
  input.accept = options?.acceptFileTypes ?? ".txt,.csv,.json";
  await clickInputWithRejectHandler(input);
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = (e) => {
      if (fr.result)
        resolve(fr.result);
      else
        reject();
    };
    fr.onerror = (e) => reject(e.target.error);
    fr.onabort = () => reject();
    fr.readAsText(
      input.files[0],
      forcedEncoding || (navigator.platform.indexOf("Linux") !== -1 || navigator.platform.indexOf("Mac") !== -1 ? "UTF-8" : "CP1252")
    );
  });
}
var askForFile = async (options) => {
  const input = document.createElement("input");
  if (options?.acceptMultipleFiles)
    input.setAttribute("multiple", "");
  input.type = "file";
  if (options?.acceptFileTypes)
    input.accept = options.acceptFileTypes;
  await clickInputWithRejectHandler(input);
  return input.files;
};
var askForImage = async (options = { quality: 100, resultType: CameraResultType.DataUrl }) => {
  try {
    const photo = await Camera.getPhoto({ ...options, resultType: CameraResultType.DataUrl });
    return dataURLtoFile(photo.dataUrl, "image.png");
  } catch (e) {
    if (e.message?.includes("User cancelled"))
      throw e;
    console.warn("Couldn't use Camera.getPhoto, will fallback to askForFile instead. Error: ", e);
    try {
      const files = await askForFile({ acceptFileTypes: ".jpg,.jpeg,.png,.webp" });
      if (!files)
        return;
      return files[0];
    } catch (e2) {
      return;
    }
  }
};
export {
  askForFile,
  askForImage,
  askForTextFile,
  download,
  downloadLink
};
